import React from "react";
import "./footer.scss";
import { Link } from "react-router-dom";
import bg from "../../assets/footer-bg.jpg";
import logo from "../../assets/the-movie-egg.png";
const Footer = () => {
  return (
    <div className="footer" style={{ backgroundImage: `url(${bg})` }}>
      <div className="footer__content container">
        <div className="footer__content__logo">
          <div className="logo">
            <img src={logo} alt="logo" />
            <Link to="/">The Movies Egg</Link>
          </div>
        </div>
        <div className="footer__content__menus">
          <div className="footer__content__menu">
            <Link to="/">Home</Link>
            <Link to="/">Contact Us</Link>
            <Link to="/">Terms Of Services</Link>
            <Link to="/">About Us</Link>
          </div>
          <div className="footer__content__menu">
            <Link to="/">Live</Link>
            <Link to="/">FAQ</Link>
            <Link to="/">Premium</Link>
            <Link to="/">Privacy Policy</Link>
          </div>
          <div className="footer__content__menu">
            <Link to="/">You must watch</Link>
            <Link to="/">Recent Release</Link>
            <Link to="/">Top IMDB</Link>
          </div>
        </div>
      </div>
      <h3 style={{ textAlign: "center", paddingTop: "80px" }}>
        Copyright &copy; {new Date().getFullYear()}{" "}
        <a href="#">The Movies Egg</a>. All Rights Reserved.
      </h3>
      <br />
      <h4 style={{ textAlign: "center" }}>
        Developed and Designed by ❤{" "}
        <a
          href="https://anirban-majumdar-97.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Anirban K Majumdar
        </a>
      </h4>
    </div>
  );
};

export default Footer;
